import { isValidElement, ReactNode } from 'react';
import { IconMinus, IconX, TablerIcon } from '@rossum/ui/icons/tabler';
import {
  IconButton,
  DialogTitle as MuiDialogTitle,
  Paper,
  Stack,
  SvgIcon,
  Typography,
} from '@rossum/ui/material';
import DialogTitleIcon, { DialogIconColor } from './DialogTitleIcon';

type DialogTitleProps = {
  title: ReactNode | string;
  iconBackgroundColor?: DialogIconColor;
  Icon?: TablerIcon;
  onClose?: () => void;
  onToggleMinimize?: () => void;
  closeDataCy?: string;
};

const DialogTitle = ({
  onClose,
  onToggleMinimize,
  title,
  iconBackgroundColor,
  Icon,
  closeDataCy,
}: DialogTitleProps) => (
  <MuiDialogTitle
    component={Paper}
    elevation={8}
    borderRadius={0}
    boxShadow={0}
    sx={{
      py: 2,
      px: 3,
    }}
  >
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      justifyContent="space-between"
    >
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        sx={{ width: '100%' }}
      >
        <DialogTitleIcon
          Icon={Icon}
          iconBackgroundColor={iconBackgroundColor}
        />
        <Typography
          component={isValidElement(title) ? 'div' : 'h5'}
          variant="h5"
        >
          {title}
        </Typography>
      </Stack>
      <Stack spacing={2} direction="row">
        {onToggleMinimize && (
          <IconButton size="small" onClick={onToggleMinimize}>
            <SvgIcon fontSize="large">
              <IconMinus />
            </SvgIcon>
          </IconButton>
        )}
        {onClose && (
          <IconButton
            size="small"
            onClick={onClose}
            data-cy={closeDataCy ?? 'dialog-close-button'}
          >
            <SvgIcon fontSize="large">
              <IconX />
            </SvgIcon>
          </IconButton>
        )}
      </Stack>
    </Stack>
  </MuiDialogTitle>
);

export default DialogTitle;
